// auth

export const AUTH_ERROR = 'Authentication error - please try again';
export const AUTH_TIMEOUT = 'Authentication timeout - please try again';
